module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer007"
    }
  }, [_c('p', {
    staticClass: "CN"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor149"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor150"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor151"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor152"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor153"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor154"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor155"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor156"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor157"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor158"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor159"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor160"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor161"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor162"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor163"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor164"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor165"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor166"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor167"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor168"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor169"
    }
  }), _c('a', {
    attrs: {
      "href": "#/Thiselton_A_Shorter_Guide2#toc5"
    }
  }, [_vm._v("Chapter 2")])]), _vm._v(" "), _c('p', {
    staticClass: "CT",
    attrs: {
      "id": "_idParaDest-6"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor170"
    }
  }), _c('a', {
    attrs: {
      "href": "#/Thiselton_A_Shorter_Guide2#toc5"
    }
  }, [_vm._v("The Literature of Intertestamental Judaism")])]), _vm._v(" "), _c('p', {
    staticClass: "BODYFLUSH-L1"
  }, [_vm._v("The purpose of this chapter is quite different from that of my larger book. In the larger book on the Holy Spirit, I considered major Jewish sources from after the latest OT writers until the first century "), _c('span', {
    staticClass: "sc"
  }, [_vm._v("a.d.")]), _vm._v(" by carefully distinguishing their respective dates, cultural backgrounds, and purposes. My purpose in this smaller book is different. It is less academic and “objective.” I still take for granted that there was much interpenetration between what used to be called “Palestinian” Judaism and “Hellenistic” Judaism, as Martin Hengel, Howard Marshall, and others have urged. But for the sake of this distinctly shorter book, and its mainly Christian readers, I focus more narrowly and more briefly on major similarities and differences between developments in Judaism and a biblical theology of the Old and New Testaments, as most Christians understand these. For more detailed questions about Jewish literature, readers are referred to the larger book. First we trace the main points of affinity and contrast with the Christian Bible.")]), _vm._v(" "), _c('p', {
    staticClass: "H1"
  }, [_vm._v("1. The Main Points of Affinity, "), _c('br'), _vm._v("Which Are Greater Than the Contrasts")]), _vm._v(" "), _c('p', {
    staticClass: "BODYFLUSH"
  }, [_vm._v("(1) The intertestamental Jewish writings maintain the OT theme that the Spirit of God inspires both the Scriptures and prophecy. This applies to the OT prophets in the Dead Sea Scrolls (mostly first century "), _c('span', {
    staticClass: "sc"
  }, [_vm._v("b.c.")]), _vm._v("–first century "), _c('span', {
    staticClass: "sc"
  }, [_vm._v("a.d.")]), _vm._v("). For example, 1QS 3.7-8 ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Manual of")]), _vm._v(" "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Discipline")]), _vm._v(") suggests that the Spirit inspired the OT prophets when it comments on Neh. 9:30: “You . . . warned them by your Spirit through the prophets; yet they would not listen.” Similarly the same passage comments on Zech. 7:12: “the words that the Lord of hosts had sent by his Spirit through the former prophets.”")]), _vm._v(" "), _c('p', {
    staticClass: "BODY"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor171"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor172"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor173"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor174"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor175"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor176"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor177"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor178"
    }
  }), _vm._v("In the Apocryphal Books, Jub. 31:12 recounts, “And the Spirit of prophecy came down into his mouth” (where “came down” suggests that this is not merely the human spirit). Jubilees 25:14 and 31:12 speak of “the Spirit of prophecy” (NRSV, regularly, “spirit”).")]), _vm._v(" "), _c('p', {
    staticClass: "BODY"
  }, [_vm._v("In Greek-­speaking Jewish literature, Philo of Alexandria (c. 20 "), _c('span', {
    staticClass: "sc"
  }, [_vm._v("b.c.")]), _vm._v("–"), _c('span', {
    staticClass: "sc"
  }, [_vm._v("a.d.")]), _vm._v(" 50) regards the Spirit as inspiring the OT ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("On the Life of Moses, ")]), _vm._v("1.175; 1.277; 2.191; "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("On the Virtues, ")]), _vm._v("217-19; "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("On Dreams, ")]), _vm._v("2.252; "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("On the Special Laws, ")]), _vm._v("4.49; and elsewhere). The prophet can be completely overborne by the Spirit. The Greek-­speaking, pro-­Roman, Jewish writer Josephus (c. "), _c('span', {
    staticClass: "sc"
  }, [_vm._v("a.d. ")]), _vm._v("37–100) shares the same view (Josephus, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Antiquities, ")]), _vm._v("4.199; 8.4.3). Schlechter insists, “To them (the Rabbis) the whole of the Torah (was) . . . dictated by the . . . Spirit,” citing a number of rabbinic passages."), _c('span', {
    staticClass: "noteref _idGenCharOverride-1"
  }, [_c('span', {
    attrs: {
      "id": "footnote-033-backlink"
    }
  }, [_c('a', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Thiselton_A_Shorter_Guide7#footnote-033"
    }
  }, [_vm._v("1")])])])]), _vm._v(" "), _c('p', {
    staticClass: "BODY"
  }, [_vm._v("A standard treatment of the Spirit in Judaism has been offered by John Levison (2002)."), _c('span', {
    staticClass: "noteref _idGenCharOverride-1"
  }, [_c('span', {
    attrs: {
      "id": "footnote-032-backlink"
    }
  }, [_c('a', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Thiselton_A_Shorter_Guide7#footnote-032"
    }
  }, [_vm._v("2")])])]), _vm._v(" This updated an earlier treatment by Erik Sjöberg and, less directly, by Eduard Schweizer in Kittel’s "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("TDNT.")]), _c('span', {
    staticClass: "noteref _idGenCharOverride-1"
  }, [_c('span', {
    attrs: {
      "id": "footnote-031-backlink"
    }
  }, [_c('a', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Thiselton_A_Shorter_Guide7#footnote-031"
    }
  }, [_vm._v("3")])])]), _vm._v(" Schweizer refers to “the typically Jewish idea that the Spirit is the Spirit of prophecy” in the context of the background to Luke."), _c('span', {
    staticClass: "noteref _idGenCharOverride-1"
  }, [_c('span', {
    attrs: {
      "id": "footnote-030-backlink"
    }
  }, [_c('a', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Thiselton_A_Shorter_Guide7#footnote-030"
    }
  }, [_vm._v("4")])])]), _vm._v(" Max Turner and Robert Menzies undertook studies of Jewish literature as background to the Holy Spirit in Luke, especially in relation to the charismatic and Pentecostal movements, respectively."), _c('span', {
    staticClass: "noteref _idGenCharOverride-1"
  }, [_c('span', {
    attrs: {
      "id": "footnote-029-backlink"
    }
  }, [_c('a', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Thiselton_A_Shorter_Guide7#footnote-029"
    }
  }, [_vm._v("5")])])]), _vm._v(" Turner cites such standard sources as 1 Enoch 91:1 and 4 Ezra 14:22 in the Pseudepigrapha, and Sir. 48:4 and Jub. 71:12 in the Apocrypha. He also cites the Dead Sea Scrolls, e.g. 1QS 8.16.")]), _vm._v(" "), _c('p', {
    staticClass: "BODY"
  }, [_vm._v("A problem arises, however, in Turner’s citations from the Targums. These were Aramaic paraphrases of the Hebrew OT, mainly used in synagogue services. Admittedly some texts date from before the NT, but the earliest traditions were oral, not written, and the written text of the Babylonian Targum Onqelos dates only from the mid-second century "), _c('span', {
    staticClass: "sc"
  }, [_vm._v("a.d.")]), _vm._v(" The Palestinian Targum Pseudo-­Jonathan dates from a little later. It is possible "), _c('a', {
    attrs: {
      "id": "_idTextAnchor179"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor180"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor181"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor182"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor183"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor184"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor185"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor186"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor187"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor188"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor189"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor190"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor191"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor192"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor193"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor194"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor195"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor196"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor197"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor198"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor199"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor200"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor201"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor202"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor203"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor204"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor205"
    }
  }), _vm._v("that they reflect earlier traditions, but we cannot be entirely certain about individual texts. They are therefore not always reliable as influences on the NT writers. The most that we can say is that Turner cites numerous examples of Targumic comments on passages in Genesis and elsewhere that ascribe prophecy to the Spirit; he uses examples from the Jacob and Rebekah stories, among others."), _c('span', {
    staticClass: "noteref _idGenCharOverride-1"
  }, [_c('span', {
    attrs: {
      "id": "footnote-028-backlink"
    }
  }, [_c('a', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Thiselton_A_Shorter_Guide7#footnote-028"
    }
  }, [_vm._v("6")])])]), _vm._v(" Nevertheless, the theme that the Spirit inspires Scripture and prophecy cannot be doubted.")]), _vm._v(" "), _c('p', {
    staticClass: "BODY"
  }, [_vm._v("(2) Closely related to this is a second theme that the Spirit inspires study of the law and is the source of wisdom and holiness. The Greek Wis. Sol. 9:17 reads: “Who has learned your counsel, unless you have given wisdom and sent your Holy Spirit from on High?” Paul takes this up in 1 Cor. 2:6-15, especially vv. 10-13, which is almost a quotation. God is a “Spirit of Truth” (1QS 4.20-21). Philo believes that the Spirit inspired the Scriptures and their reading ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("On the Life of Moses, ")]), _vm._v("2.191; 1.277). It is unnecessary to belabor the point.")]), _vm._v(" "), _c('p', {
    staticClass: "BODY"
  }, [_vm._v("(3) The Spirit is personal or suprapersonal, and radiates God’s presence and activity. Sjöberg writes, “There are many instances of the Spirit speaking, crying, admonishing, sorrowing, weeping, rejoicing, comforting.”"), _c('span', {
    staticClass: "noteref _idGenCharOverride-1"
  }, [_c('span', {
    attrs: {
      "id": "footnote-027-backlink"
    }
  }, [_c('a', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Thiselton_A_Shorter_Guide7#footnote-027"
    }
  }, [_vm._v("7")])])])]), _vm._v(" "), _c('p', {
    staticClass: "BODY"
  }, [_vm._v("(4) The Spirit will equip a Messianic figure to bring salvation to God’s people. In the nationalistic and apocalyptic Psalms of Solomon, the author builds up the picture of a warrior-­messianic figure who will restore his people: “God will make him mighty by means of his holy Spirit, and wise by . . . the spirit of understanding” (Ps. Sol. 17:42). He will “shepherd his flock” (14:45) and lead them (v. 46). 1QS 9.11 speaks of the priestly messiah of Aaron and the kingly messiah of Israel.")]), _vm._v(" "), _c('p', {
    staticClass: "H1"
  }, [_vm._v("2. The Main Points of Contrast and Difference")]), _vm._v(" "), _c('p', {
    staticClass: "BODYFLUSH"
  }, [_vm._v("(1) The most striking and glaring contrast with the NT is that often in Jewish literature the Spirit of God is a reward for holiness and obedience, whereas in Paul and the apostolic Church the Spirit of God is the cause of holiness and obedience. Sjöberg writes, “The gift of the Spirit is espe"), _c('a', {
    attrs: {
      "id": "_idTextAnchor206"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor207"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor208"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor209"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor210"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor211"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor212"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor213"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor214"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor215"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor216"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor217"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor218"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor219"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor220"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor221"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor222"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor223"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor224"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor225"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor226"
    }
  }), _vm._v("cially viewed as a reward for a righteous life.”"), _c('span', {
    staticClass: "noteref _idGenCharOverride-1"
  }, [_c('span', {
    attrs: {
      "id": "footnote-026-backlink"
    }
  }, [_c('a', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Thiselton_A_Shorter_Guide7#footnote-026"
    }
  }, [_vm._v("8")])])]), _vm._v(" Rabbi Acha declared, “He who sacrifices himself for Israel will receive . . . the Holy Spirit” (Numbers Rabbah 15:20). We may also compare Rabbi Nehemiah commenting on Exod. 15:1, “He who undertakes a commandment in faith is worthy that the Holy Spirit should rest on him” (Mekilta Exodus 15:1, a Tannaitic Midrash on Exodus 15). Sjöberg also cites Genesis Rabbah 91:6 (on Gen. 41:1), and other sources. These stand in utter contrast to Gal. 3:1-5, where Paul asks with rhetorical irony: “Did you receive the Spirit by doing the works of the law or by believing what you heard?” (v. 2). We may grant that the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("intention")]), _vm._v(" was to urge the case for purity and holiness. Even some Christian holiness groups, like the extreme “Radical” Reformers, verged towards the edge of this abyss. Luther exclaimed that this undermined his theme of justification by grace through faith alone. It utterly undermined the free sovereign grace of God in Christ.")]), _vm._v(" "), _c('p', {
    staticClass: "BODY"
  }, [_vm._v("(2) Although we cannot draw an over-­sharp line between the transcendence and immanence of God, who is both beyond the world and within it, the Jewish writings, especially those influenced by Greek speculations, tended to stress the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("immanence")]), _vm._v(" of the Spirit at the expense of his otherness. Wisdom 12:1 begins, “Your immortal spirit is in all things.” This is not strictly wrong. It expresses “panentheism” rather than pantheism. To be fair, Montague stresses: “Probably in the view of the rest of the Bible, the breath of life never ceases to be God’s”; it is only “on loan to man during his earthly life (Wis. 15:16).”"), _c('span', {
    staticClass: "noteref _idGenCharOverride-1"
  }, [_c('span', {
    attrs: {
      "id": "footnote-025-backlink"
    }
  }, [_c('a', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Thiselton_A_Shorter_Guide7#footnote-025"
    }
  }, [_vm._v("9")])])]), _vm._v(" Yet Paul carefully distances himself from a one-sided emphasis on immanence in 1 Cor. 2:10-13. In contrast to a Stoic notion of the Spirit as the “soul” of the world, he calls the Holy Spirit the One who "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("comes forth from God")]), _vm._v(" (2:12). The Greek construction here could be translated literally, “the Spirit, the out-­of-­God One” (NRSV, “the Spirit that is from God”). We must urge again that this emphasis in Judaism is largely due to the influence of Hellenistic ideas in Diaspora Judaism, where sheer numbers of Jews outnumbered those in the Holy Land.")]), _vm._v(" "), _c('p', {
    staticClass: "BODY"
  }, [_vm._v("(3) In the same vein the Spirit of God was sometimes "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("insufficiently distinguished")]), _vm._v(" "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("from sheer rationality, ")]), _vm._v("in both God and humankind. Again, the line is blurred, because reason and order indeed come from God. Only in certain revivalist circles is the Spirit of God ever associated with chaos or confusion. The Spirit at creation explicitly brought order out of chaos. But "), _c('a', {
    attrs: {
      "id": "_idTextAnchor227"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor228"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor229"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor230"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor231"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor232"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor233"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor234"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor235"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor236"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor237"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor238"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor239"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor240"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor241"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor242"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor243"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor244"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor245"
    }
  }), _vm._v("if reason or reasonableness is regarded as the Spirit himself, rather than as "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("effects")]), _vm._v(" of the Spirit, we have crossed the line which separates God from all that is human and created.")]), _vm._v(" "), _c('p', {
    staticClass: "BODY"
  }, [_vm._v("Nevertheless, this trend remains a tricky one to define, because the Spirit bears a close relation to Wisdom in both the OT and Judaism. We may, however, say that Paul maintains a sharp contrast between human wisdom and the Wisdom of God in Christ in 1 Cor. 1:18-2:5: “In the Wisdom of God, the world did not know God through wisdom” (1:21). We must not, however, overstate the contrast; we merely note a divergent trend. We have already encroached on some NT issues, so it is time to turn to the NT writers themselves. We conclude that out of a possibly longer list, at least four characteristic features of the Spirit of God are shared by Judaism and the NT on the basis of the OT, but at least three offer points of difference and contrast, largely because of Greek influences.")]), _vm._v(" "), _c('div', {
    staticClass: "_idFootnotes"
  }, [_c('div', {
    staticClass: "_idFootnote",
    attrs: {
      "id": "footnote-033"
    }
  }, [_c('p', {
    staticClass: "FN"
  }, [_c('a', {
    staticClass: "_idFootnoteAnchor _idGenColorInherit",
    attrs: {
      "href": "#/Thiselton_A_Shorter_Guide7#footnote-033-backlink"
    }
  }, [_vm._v("1")]), _vm._v(". S. Schlechter, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Some Aspects of Rabbinic Theology")]), _vm._v(" (London: Black, 1909), p. 120; he cites Gen. Rab., 85.2; "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Sifre, ")]), _vm._v("33a; "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Sanhedrin, ")]), _vm._v("99B; and others.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idFootnote",
    attrs: {
      "id": "footnote-032"
    }
  }, [_c('p', {
    staticClass: "FN"
  }, [_c('a', {
    staticClass: "_idFootnoteAnchor _idGenColorInherit",
    attrs: {
      "href": "#/Thiselton_A_Shorter_Guide7#footnote-032-backlink"
    }
  }, [_vm._v("2")]), _vm._v(". John R. Levison, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Spirit in First-­­Century Judaism")]), _vm._v(" (Leiden: Brill, 2002).")])]), _vm._v(" "), _c('div', {
    staticClass: "_idFootnote",
    attrs: {
      "id": "footnote-031"
    }
  }, [_c('p', {
    staticClass: "FN"
  }, [_c('a', {
    staticClass: "_idFootnoteAnchor _idGenColorInherit",
    attrs: {
      "href": "#/Thiselton_A_Shorter_Guide7#footnote-031-backlink"
    }
  }, [_vm._v("3")]), _vm._v(". Erik Sjöberg, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("“Pneuma, pneumatikos, pne")]), _c('em', {
    staticClass: "italic"
  }, [_vm._v("ō")]), _c('em', {
    staticClass: "italic"
  }, [_vm._v(", empne")]), _c('em', {
    staticClass: "italic"
  }, [_vm._v("ō, pnoē, ekpneō, theopneustos: ")]), _vm._v("C.III. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Rûaḥ ")]), _vm._v("in Palestinian Judaism,” in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("TDNT, ")]), _vm._v("6.375-89; Schweizer provided the latter part of the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("“Pneuma, pneumatikos” ")]), _vm._v("entry ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("TDNT, ")]), _vm._v("6.389-455), covering the Spirit in Gnosticism, the New Testament, and the post-apostolic fathers. ")])]), _vm._v(" "), _c('div', {
    staticClass: "_idFootnote",
    attrs: {
      "id": "footnote-030"
    }
  }, [_c('p', {
    staticClass: "FN"
  }, [_c('a', {
    staticClass: "_idFootnoteAnchor _idGenColorInherit",
    attrs: {
      "href": "#/Thiselton_A_Shorter_Guide7#footnote-030-backlink"
    }
  }, [_vm._v("4")]), _vm._v(". Eduard Schweizer, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("“Pneuma, pneumatikos, pne")]), _c('em', {
    staticClass: "italic"
  }, [_vm._v("ō")]), _c('em', {
    staticClass: "italic"
  }, [_vm._v(", empne")]), _c('em', {
    staticClass: "italic"
  }, [_vm._v("ō, pnoē, ekpneō, theopneustos: ")]), _vm._v("E.II. Luke and Acts,” in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("TDNT, ")]), _vm._v("6.404-15, here 407.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idFootnote",
    attrs: {
      "id": "footnote-029"
    }
  }, [_c('p', {
    staticClass: "FN"
  }, [_c('a', {
    staticClass: "_idFootnoteAnchor _idGenColorInherit",
    attrs: {
      "href": "#/Thiselton_A_Shorter_Guide7#footnote-029-backlink"
    }
  }, [_vm._v("5")]), _vm._v(". Max Turner, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Power from on High: The Spirit in Israel’s Restoration and Witness in Luke–Acts")]), _vm._v(" (Sheffield: Sheffield Academic Press, 2000), esp. pp. 82-138; and Robert Menzies, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Empowered for")]), _vm._v(" "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Witness: The Spirit in Luke–Acts")]), _vm._v(" (Sheffield: Sheffield Academic Press, 1994).")])]), _vm._v(" "), _c('div', {
    staticClass: "_idFootnote",
    attrs: {
      "id": "footnote-028"
    }
  }, [_c('p', {
    staticClass: "FN"
  }, [_c('a', {
    staticClass: "_idFootnoteAnchor _idGenColorInherit",
    attrs: {
      "href": "#/Thiselton_A_Shorter_Guide7#footnote-028-backlink"
    }
  }, [_vm._v("6")]), _vm._v(". Turner, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Power from on High, ")]), _vm._v("p. 87; he discusses Gen. 27:5, 42; 30:26-27, 33; 43:14; etc.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idFootnote",
    attrs: {
      "id": "footnote-027"
    }
  }, [_c('p', {
    staticClass: "FN"
  }, [_c('a', {
    staticClass: "_idFootnoteAnchor _idGenColorInherit",
    attrs: {
      "href": "#/Thiselton_A_Shorter_Guide7#footnote-027-backlink"
    }
  }, [_vm._v("7")]), _vm._v(". Sjöberg, “"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Rûaḥ ")]), _vm._v("in Palestinian Judaism,” 6.386.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idFootnote",
    attrs: {
      "id": "footnote-026"
    }
  }, [_c('p', {
    staticClass: "FN"
  }, [_c('a', {
    staticClass: "_idFootnoteAnchor _idGenColorInherit",
    attrs: {
      "href": "#/Thiselton_A_Shorter_Guide7#footnote-026-backlink"
    }
  }, [_vm._v("8")]), _vm._v(". Sjöberg, “"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Rûaḥ ")]), _vm._v("in Palestinian Judaism,” 6.383.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idFootnote",
    attrs: {
      "id": "footnote-025"
    }
  }, [_c('p', {
    staticClass: "FN"
  }, [_c('a', {
    staticClass: "_idFootnoteAnchor _idGenColorInherit",
    attrs: {
      "href": "#/Thiselton_A_Shorter_Guide7#footnote-025-backlink"
    }
  }, [_vm._v("9")]), _vm._v(". George Montague, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Holy Spirit: The Growth of a Biblical Tradition")]), _vm._v(" (Eugene, OR: Wipf & Stock, 1976), p. 102.")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-56b1569a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Thiselton_A_Shorter_Guide-7.vue
// module id = 75
// module chunks = 0